<div
    class="cmps-cdk-px-1 cmps-cdk-my-0dot5"
    #ref
></div>
<div
    class="cmps-cdk-mb-0dot5"
    *ngFor="let a of group?.areas"
>
    <cmps-ca-evaluation-focus
        [group]="group"
        [area]="a"
    ></cmps-ca-evaluation-focus>
</div>
